import axios from 'axios'
import { API_TIMEOUT } from '../app_constant'

export const getMyConfig = (isOepnApi, data = null) => {
  let token = JSON.parse(localStorage.getItem('token'))

  var config = {}
  // config.timeout = API_TIMEOUT
  config.headers = {
    'Content-Type': 'application/json'
  }

  if (token !== null) {
    var authKey = {
      'auth-key': `Token ${token}`
    }

    config.headers = authKey
  }

  if (data != null) {
    config.params = data
  }

  return config
}

export const post = async (url, params, thunkAPI, isOepnApi = false) => {
  try {
    const response = await axios.post(url, params, getMyConfig(isOepnApi))
    return response.data
  } catch (error) {
    if (error.response.status === 401) {
      // Handle 401 Unauthorized error
      localStorage.clear()
      window.location.reload();
    } else {
      // Handle other errors
      console.error(error);
    }
    return thunkAPI.rejectWithValue({ custom_error: error.message })
  }
}

export const put = async (url, params, thunkAPI, isOepnApi = false) => {
  try {
    const response = await axios.put(url, params, getMyConfig(isOepnApi))
    return response.data
  } catch (error) {
    if (error.response.status === 401) {
      // Handle 401 Unauthorized error
      localStorage.clear()
      window.location.reload();
    } else {
      // Handle other errors
      console.error(error);
    }
    return thunkAPI.rejectWithValue({ custom_error: error.message })
  }
}

export const get = async (url, params, thunkAPI, isOepnApi = false) => {
  try {
    if (params != null && params != undefined) {
      const response = await axios.get(url, getMyConfig(isOepnApi, params))
      return response.data

    } else {
      const response = await axios.get(url, getMyConfig(isOepnApi))
      return response.data
    }
  } catch (error) {
    if (error.response.status === 401) {
      // Handle 401 Unauthorized error
      localStorage.clear()
      window.location.reload();
    } else {
      // Handle other errors
      console.error(error);
    }
    return thunkAPI.rejectWithValue({ custom_error: error.message })
  }
}


